import Vue from "vue";
import { checkResponse } from "@/helpers/store";

const state = {
  acceptedShipmentReport: null
};

const mutations = {
  setAcceptedShipmentReport: (state, payload) =>
    (state.acceptedShipmentReport = payload),
  clearAcceptedShipmentReport: state => (state.acceptedShipmentReport = null)
};

const actions = {
  async getAcceptedShipmentReport({ commit, rootState }, { period }) {
    try {
      commit("setFullPageLoading", true);

      const response = await Vue.axios.post(
        rootState.auth.base.url,
        {
          cmd: "luaFunc",
          params: {
            script: "web.report_osr",
            funcname: "reportosr",
            period: `${period}`
          }
        },
        {
          headers: {
            Authorization: `{"token":["${rootState.auth.user.token}","${rootState.auth.user.tokenid}"]}`
          }
        }
      );

      const result = checkResponse(commit, response);
      if (result == "ok") {
        commit("setAcceptedShipmentReport", response.data);
      } else {
        commit("setError", result);
      }
    } catch (error) {
      commit("setError", error);
    } finally {
      commit("setFullPageLoading", false);
    }
  }
};

const getters = {
  acceptedShipmentReport: state => state.acceptedShipmentReport
};

export default { state, mutations, actions, getters };
